export default {"src":"/_next/static/media/horizontal_view.eb1b2517.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};